import Account from '@/models/accounts/account.model';

export default class AccountList {
  _accounts = [];

  constructor(accounts = []) {
    this._accounts = accounts;
  }

  static fromJson(json) {
    const profile = json['profile'];
    const accounts = Array.isArray(profile['account']) ? profile['account'] : [profile['account']];

    return new AccountList(
      accounts.map((account) => {
        return Account.fromJson(account);
      })
    );
  }
}
